<template>
  <div :class="counterClasses">
    <button
      @click="$emit('minus')"
      class="calc-button minus"
    ></button>
      <ValueDisplay>{{ value }}</ValueDisplay>
    <button
      @click="$emit('plus')"
      class="calc-button plus"
    ></button>
  </div>
</template>

<script>
import ValueDisplay from './ValueDisplay'

export default {
  name: 'Counter',
  props: {
    value: {
      type: Number,
      required: true
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValueDisplay
  },
  computed: {
    counterClasses () {
      return {
        'counter': true,
        'light': this.light,
        'dark': !this.light
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.counter {
  line-height: 60px;
  margin: 0.5em auto;
}

.calc-button {
  background: none;
  border: none;
  cursor: pointer;
  width: 0;
  height: 0;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  border-radius: 0;
}

.light {
  .minus {
    border-right: 18px solid #191f2d;
  }

  .plus {
    border-left: 18px solid #191f2d;
  }
}

.dark {
  .minus {
    border-right: 18px solid white;
  }

  .plus {
    border-left: 18px solid white;
  }
}
</style>
